// src/AppRoutes.jsx
import React from 'react'
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom'
import Login from './components/Login'
import Register from './components/Register'
import Dashboard from './components/Dashboard/Dashboard'
import DashboardLayout from './components/Dashboard/DashboardLayout'
import AddProgram from './components/Forms/AddProgram'
import AddSchedule from './components/Forms/AddSchedule'
import AddQualification from './components/Forms/AddQualification'
import AddPerson from './components/Forms/AddPerson'
import AddCompany from './components/Forms/AddCompany'
import AddTopic from './components/Forms/AddTopic'
import AddRubrica from './components/Forms/AddRubrica'
import PrerollsPage from './components/Prerolls/PrerollsPage'
import PrerollsPageExt from './components/Prerolls/PrerollsPageExt'
import TicketsPage from './components/Tickets/TicketsPage'
import TurnazionePage from './components/Turnazione/TurnazionePage'
import InstagramPage from './components/Instagram/InstagramPage'
import LiveChatPage from './components/LiveChat/LiveChatPage'
import PlaylistPage from './components/Playlist/PlaylistPage'
import MediaConverterPage from './components/MediaConverter/MediaConverterPage'
import SurveyAnalyticsPage from './components/SurveyAnalytics/SurveyAnalyticsPage'
import ActivitiesPage from './components/Activities/ActivitiesPage'
import { AuthProvider } from './contexts/AuthContext'
import { DashboardProvider } from './contexts/DashboardContext'
import RequireAuth from './components/Auth/RequireAuth'
import LandingRedirect from './components/Auth/LandingRedirect'

export default function AppRoutes() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* pubbliche */}
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* protette - wrappate con DashboardProvider */}
          <Route element={<RequireAuth />}>
            <Route element={<DashboardProviderWrapper />}>
              <Route element={<DashboardLayout />}>
                <Route path="/dashboard"         element={<Dashboard />} />
                <Route path="/add-program"       element={<AddProgram />} />
                <Route path="/add-schedule"      element={<AddSchedule />} />
                <Route path="/add-qualification" element={<AddQualification />} />
                <Route path="/add-person"        element={<AddPerson />} />
                <Route path="/add-company"       element={<AddCompany />} />
                <Route path="/add-topic"         element={<AddTopic />} />
                <Route path="/add-rubrica"       element={<AddRubrica />} />
                <Route path="/prerolls"          element={<PrerollsPage />} />
                <Route path="/prerolls-ext"      element={<PrerollsPageExt />} />
                <Route path="/tickets"           element={<TicketsPage />} />
                <Route path="/tickets/:ticketId"  element={<TicketsPage />} />
                <Route path="/turnazione"        element={<TurnazionePage />} />
                <Route path="/instagram"         element={<InstagramPage />} />
                <Route path="/live-chat"         element={<LiveChatPage />} />
                <Route path="/playlist"          element={<PlaylistPage />} />
                <Route path="/media-converter"   element={<MediaConverterPage />} />
                <Route path="/survey-analytics"  element={<SurveyAnalyticsPage />} />
                <Route path="/activities"        element={<ActivitiesPage />} />
              </Route>
            </Route>
          </Route>

          {/* default dinamico */}
          <Route path="*" element={<LandingRedirect />} />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

/**
 * Wrapper per DashboardProvider come layout route
 */
function DashboardProviderWrapper() {
  return (
    <DashboardProvider>
      <Outlet />
    </DashboardProvider>
  )
}
